var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DCP-Manage-Rides",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-1008.000000, -459.000000)",
    fill: "#FF5F00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_suitcase",
    transform: "translate(1007.000000, 457.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6664667,5.33333333 L5.33313333,5.33333333 L5.33313333,12.6666667 L10.6664667,12.6666667 L10.6664667,5.33333333 L10.6664667,5.33333333 Z M11.9998,5.33333333 L11.9998,12.6666667 L13.3333333,12.6666667 L13.3333333,5.33333333 L11.9998,5.33333333 Z M3.9998,5.33333333 L2.66666667,5.33333333 L2.66666667,12.6666667 L3.9998,12.6666667 L3.9998,5.33333333 Z M5.33333333,4 L5.33333333,2 L10.6666667,2 L10.6666667,4 L14.6666667,4 L14.6666667,14 L1.33333333,14 L1.33333333,4 L5.33333333,4 Z M6.66666667,4 L9.33333333,4 L9.33333333,3.33333333 L6.66666667,3.33333333 L6.66666667,4 Z",
    id: "shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.dbbe547ebc05362b7ded980797953b84.svg";
export { ForwardRef as ReactComponent };